<template>
  <div v-loading="loading" class="radish-list">
    <div v-if="searchReady" class="radish-search">
      <div v-if="searchMode == 'simple'" class="simple">
        <template v-for="i in 4">
          <formItem
            v-if="searchFields[searchOrder[i - 1]]"
            :key="searchFields[searchOrder[i - 1]].label + 's'"
            :type="searchFields[searchOrder[i - 1]].type"
            :is-inline="true"
            :width="searchFields[searchOrder[i - 1]].width"
            :label-width="searchFields[searchOrder[i - 1]].labelWidth"
            :label="searchFields[searchOrder[i - 1]].label"
            :display-label="searchFields[searchOrder[i - 1]].displayLabel"
            :options="searchFields[searchOrder[i - 1]].options"
            :content="searchData[searchFields[searchOrder[i - 1]].label]"
            :handle-data-change="handleSearchChange"
          ></formItem>
        </template>
        <el-button icon="el-icon-arrow-down" type="text" size="mini" @click="setMode('complete')">展开</el-button>
        <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
        <el-button size="mini" round @click="cleanSearch">清空</el-button>
        <el-button size="mini" round @click="orderCondition">搜索项顺序</el-button>
      </div>
      <div v-if="searchMode == 'complete'" class="complete">
        <template v-for="f in searchOrder">
          <formItem
            v-if="searchFields[f]"
            :key="searchFields[f].label"
            :type="searchFields[f].type"
            :is-inline="true"
            :width="searchFields[f].width"
            :label-width="searchFields[f].labelWidth"
            :label="searchFields[f].label"
            :display-label="searchFields[f].displayLabel"
            :options="searchFields[f].options"
            :content="searchData[searchFields[f].label]"
            :handle-data-change="handleSearchChange"
          ></formItem>
        </template>
        <div class="form-item">
          <label>目标公司</label>
          <span :title="searchData['目标公司'] || ''"
            >（已选择{{ searchData['目标公司'] ? searchData['目标公司'].length : 0 }}家）</span
          >
          <el-button type="text" size="mini" @click="showTargetCompany">选择</el-button>
        </div>
        <div style="padding:5px">
          <el-button icon="el-icon-arrow-up" type="text" size="mini" @click="setMode('simple')">收起</el-button>
          <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
          <el-button size="mini" round @click="cleanSearch">清空</el-button>
          <el-button size="mini" round @click="orderCondition">搜索项顺序</el-button>
        </div>
      </div>
    </div>
    <div ref="radishTableWapper">
      <a-table
        ref="radishTable"
        :data="radishes"
        :heads="tableHeads"
        :height="tableHeight"
        :active-row-id="activeRowId"
        :storage-name="storageName"
        :start="limit * (page - 1)"
        :on-set-hidden-cell="setHiddenCell"
        :on-set-cell-order="setCellOrder"
      >
        <template slot="actions">
          <div class="radish-act-grp">
            批量： <span v-if="defaultProject._id">当前项目【{{ defaultProject.label }}】</span>
            <div class="radish-btn radish-btn-primary" @click="showIntoProject(true)">加入项目</div>
            <div class="radish-btn radish-btn-primary" @click="showRecommend(true)">推荐</div>
            <div class="radish-btn radish-btn-primary" @click="showEditDialog">修改字段内容</div>
            <div class="radish-btn radish-btn-primary" @click="showCateDialog('添加')">添加职能模块</div>
            <div class="radish-btn radish-btn-primary" @click="showCateDialog('删除')">删除职能模块</div>
            <div class="radish-btn radish-btn-primary" @click="addToFavorite">加入收藏夹</div>
          </div>
          &nbsp;&nbsp;
          <div class="radish-act-grp">
            <el-radio-group v-model="ccSearch" size="mini">
              <el-radio-button label="all">所有</el-radio-button>
              <el-radio-button label="nocc">不看cc</el-radio-button>
              <el-radio-button label="cc">只看cc</el-radio-button>
            </el-radio-group>
          </div>
          <slot name="btns"></slot>
        </template>
      </a-table>
    </div>
    <Popper id="radish-popper" :visible.sync="popperVisible" :target-id="popperTarget">
      <div class="radish-pop">
        <!-- <FileTable
          v-if="popperContent == 'files'"
          :files="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :paginate="false"
          :on-delete="deleteAttachment"
          width="600"
          height="300"
        /> -->
        <AttachmentsType
          v-if="popperContent == 'files'"
          :attach="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :paginate="false"
          :on-delete="deleteAttachment"
          :width="600"
          :height="300"
        />
        <span v-if="popperContent == 'action'">
          <el-button size="mini" @click="showIntoProject(false)">加入项目</el-button>
          <el-button v-if="currentRow['手机']" size="mini" @click="showRecommend(false)">推荐</el-button>
          <el-button size="mini" @click="uploadCv()">上传简历</el-button>
          <el-button size="mini" @click="uploadReport()">上传推荐报告</el-button>
          <el-button size="mini" @click="genRepo">生成推荐报告</el-button>
        </span>
        <div v-if="popperContent == 'bulletin'">
          <el-table :data="bulletins" border size="mini" :resizable="false" style="width: 600px; height: 200px">
            <el-table-column
              v-for="head in bulletinHeads"
              :key="head.label"
              :prop="head.label"
              :label="head.label"
              :width="head.width"
            ></el-table-column>
          </el-table>
        </div>
        <workExp v-if="popperContent == 'comExp'" ref="workExp" :radish="currentRow"></workExp>
      </div>
    </Popper>
    <conditionDialog ref="conditionDialog"></conditionDialog>
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <explainDialog ref="explainDialog"></explainDialog>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess"></UploadDialog>
  </div>
</template>
<script>
import { Popper } from '../../project'
import conditionDialog from './dialog/condition-dialog'
import editDialog from './dialog/edit-dialog'
import cateDialog from './dialog/cate-dialog'
import explainDialog from './dialog/explain-dialog'
import { FileTable, UploadDialog } from '../../file'
import { searchFieldsMatch } from './constant/fields-list'
import tableHeads from './constant/table-heads'
import bulletinHeads from './constant/bulletin-heads'
import workExp from './components/work-exp'
import { arrRemove } from '../../project/src/constant/utils'
import AttachmentsType from './components/attachments-type'

const dateFormat = require('dateformat')

export default {
  components: {
    FileTable,
    conditionDialog,
    editDialog,
    cateDialog,
    explainDialog,
    UploadDialog,
    workExp,
    Popper,
    AttachmentsType,
  },
  mixins: [tableHeads, bulletinHeads],
  props: {
    pid: String,
    type: String,
    ids: Array,
    onConfirm: Function,
  },
  data: function() {
    return {
      loading: false,
      searchReady: false,
      catData: [],
      radishes: [],
      page: 1,
      limit: 300,
      multipleSelection: [],
      searchFields: searchFieldsMatch,
      searchOrder: [],
      searchData: { 工作年限: [0, 30] },
      searchMode: 'simple',
      yiOptions: ['Y', 'N', 'F'],
      defaultProject: {},
      tableHeight: 600,
      ccSearch: 'all',
      filesVisible: false,
      actionVisible: false,
      files: [],
      currentRow: {},
      activeRowId: '',
      popperVisible: false,
      popperContent: '',
      popperTarget: '',
      storageName: 'radishHeadsMatch',
      attachType: '',
      uploadType: '',
      bulletins: [],
      searchIds: null,
    }
  },
  computed: {
    isAdmin() {
      return app.user['角色'] && app.user['角色'].includes('管理员')
    },
  },
  watch: {
    pid: function() {
      this.setDefault()
    },
    ccSearch: function(newVal, oldVal) {
      switch (newVal) {
        case 'nocc':
          this.searchData['手机'] = '非空'
          break
        case 'cc':
          this.searchData['手机'] = '空'
          break
        default:
          this.searchData['手机'] = ''
          break
      }
      this.handleSearch()
    },
    ids: function(newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    },
  },
  mounted: async function() {
    await this.loadCate()
    if (localStorage.search_sort) {
      this.searchOrder = Object.keys(JSON.parse(localStorage.search_sort))
      for (const field in this.searchFields) {
        if (!this.searchOrder.includes(field)) {
          this.searchOrder.push(field)
        }
      }
    } else {
      this.searchOrder = Object.keys(this.searchFields)
    }
    this.searchReady = true
    // console.log(this.searchOrder)
    this.setHiddenCell()
    this.setCellOrder()
    this.setDefault()
    this.$nextTick(() => {
      this.resetTableHeight()
    })
  },
  methods: {
    loadData: async function() {
      const ids = this.searchIds ? this.searchIds : this.ids
      this.loading = true
      const res = await app.service('radish').findByIds({ ids: ids.map(item => item.id) })
      if (res.status === 'success') {
        const orderedRadish = []
        const idsObj = {}
        ids.forEach(idObj => {
          idsObj[idObj.id] = idObj.score
        })
        res.data = res.data.map(radishObj => {
          radishObj.score = idsObj[radishObj._id]
          return radishObj
        })
        res.data.sort((a, b) => {
          if (a.score > b.score) {
            return -1
          } else {
            return 1
          }
        })
        if (this.tableHeads[0].label !== '相关度') {
          this.tableHeads.unshift({
            label: '相关度',
            field: 'score',
            type: 'link',
            width: 60,
            handleContent: value => (value * 100).toFixed(3),
            onClick: async item => {
              // const result = {
              //   recommendReason: {
              //     person: { _id: 'B1--SAsO5S7', 姓名: '胡传禄' },
              //     project: { _id: 'B10RlGLm6DIm', 客户公司: '开源证券', 项目名称: '承做岗' },
              //     relatedProjs: [
              //       { _id: 'B1-FHQoMN', 客户公司: '上汽投资', 项目名称: '固收投资经理' },
              //       { _id: 'B107m2CzV', 客户公司: '新希望集团', 项目名称: '研究总监（二级）' },
              //     ],
              //     relatedPersons: [{ _id: 'B1--zQRAkR77', 姓名: '郭琪' }, { _id: 'B1-0Qlin50jIX', 姓名: '刘伟世' }],
              //   },
              // }
              const result = await app.service('project').explain({ pid: this.pid, rid: item._id })
              if (result.recommendReason) {
                this.$refs.explainDialog.show(result.recommendReason)
              }
            },
          })
        }
        this.radishes = res.data
        // console.log(this.radishes);
        this.$nextTick(function() {
          this.$refs.radishTable.setDisplay(true)
        })
        this.$emit('onLoaded', this.radishes)
      } else {
        console.error(res)
      }
      const end = Date.now()
      this.loading = false
    },
    loadOne: async function(id) {
      const res = await app.service('radish').fetch({ _id: id })
      if (res.status == 'success' && res.data.length > 0) {
        const dt = res.data[0]
        const tmp = this.radishes.map(rad => {
          if (rad._id == id) {
            rad = dt
          }
          return rad
        })
        this.radishes = tmp
        // console.log(dt)
        this.$nextTick(() => {
          this.$refs.radishTable.setDisplay(true)
        })
      }
    },
    handleSelectionChange: function(val) {
      // console.log(val)
      this.multipleSelection = val
    },
    handleSearchChange: function(res) {
      const { label, content } = res
      this.searchData[label] = content
      if (label == '职能模块') {
        this.searchReady = false
        const currentCat = this.catData.filter(cat => cat['名称'] == content)
        if (currentCat.length > 0) {
          const cat = currentCat[0]
          if (cat['二级职能'] && cat['二级职能'].length > 0) {
            const znArr = cat['二级职能']
            znArr.push('空')
            this.searchFields['细分职能'].options = znArr
          }
          if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
            const scArr = cat['擅长方向']
            this.searchFields['擅长方向'].options = scArr
          }
        }
        this.searchFields['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        this.searchReady = true
      }
    },
    handleSearch: async function() {
      const sdtStr = JSON.stringify(this.searchData)
      const sdt = JSON.parse(sdtStr)
      // console.log(sdt)
      const query = {}
      for (const field in sdt) {
        const val = sdt[field]
        if (val && val.length > 0) {
          query[field] = val
        }
      }

      console.log('q', query)
      const res = await app.service('radish').getIds({ query, pid: this.pid })
      if (res.status === 'success') {
        let ids = res.data.recommend
        if (!ids || ids.length === 0) ids = []
        ids = ids.map(v => ({
          id: v.rid || v._id,
          score: v.score,
        }))
        this.searchIds = ids
        await this.loadData()
      } else {
        this.$message.error(res.msg)
      }
    },
    cleanSearch: async function() {
      this.searchReady = false
      // console.log('clean1',this.searchData)
      this.searchData = { 工作年限: [0, 30] }
      this.searchIds = null
      await this.loadData()
      // console.log('clean',this.searchData)
      this.searchReady = true
    },
    clickName: async function(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
    clickCompany: function(companyName) {
      app.root.onPull()
      app.root.$refs.drawer.search({
        type: '公司',
        keywords: companyName,
      })
    },
    showTargetCompany: function() {
      app.root.$refs.selectCompany.open(this.searchData['目标公司'] || [], companies => {
        this.searchData['目标公司'] = companies
        this.handleSearch()
      })
      // app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.searchData['目标公司'] || [],
      //   onConfirm: companies => {
      //     // console.log(companies)
      //     this.searchData['目标公司'] = companies
      //     this.handleSearch()
      //   },
      // })
    },

    showFiles: async function(row) {
      if (row['附件'] && row['附件'] > 0) {
        const res = await app.service('radish').listAttachment({ rid: row._id })
        if (res.status == 'success') {
          this.popperVisible = true
          this.popperContent = 'files'
          this.files = res.data
          this.popperTarget = `附件${row._id}`
        } else {
          this.$message.error(res.msg)
        }
      } else {
        this.$message.info('没有附件')
      }
    },

    showAction: async function(row) {
      const res = await app.service('radish').simpleFetch({ _id: row._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      this.popperVisible = true
      this.popperContent = 'action'
      this.currentRow = row
      this.popperTarget = `操作${row._id}`
    },

    showIntoProject: function(multi) {
      let rows
      if (multi) {
        rows = this.$refs.radishTable.getChecked()
      } else {
        rows = [this.currentRow]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else if (this.defaultProject._id) {
        this.intoProject(rows)
      } else {
        app.root.$refs.radishProDialog.show(rows, 'intoProject', this.onConfirm)
      }
    },
    showRecommend: function(multi) {
      let rows
      if (multi) {
        rows = this.$refs.radishTable.getChecked()
      } else {
        rows = [this.currentRow]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        for (const row of rows) {
          if (!row['手机']) {
            this.$alert('cc候选人不能推荐', { showClose: false })
            return
          }
        }
        if (this.defaultProject._id) {
          this.recommend(rows)
        } else {
          app.root.$refs.radishProDialog.show(rows, 'recommend')
        }
      }
    },
    intoProject: async function(rows) {
      const { onkeyMatchMode } = this
      const dt = []
      rows.forEach(row => {
        dt.push({ rid: row._id, pid: this.pid, keyMatchMode: onkeyMatchMode })
      })
      const res = await app.service('radish').intoProject(dt)
      if (res.status == 'success') {
        this.$alert('加入成功', { showClose: false })
        this.onConfirm && this.onConfirm()
      } else {
        this.$alert(res.msg)
      }
    },
    recommend: async function(rows) {
      const names = []
      for (const row of rows) {
        const res = await app.service('radish').addRecommend({ rid: row._id, pid: this.pid })
        if (res.status == 'fail') {
          if (res.msg == '已推荐过') {
            names.push(row['姓名'])
          } else {
            console.log(res.msg)
          }
        }
      }
      if (names.length > 0) {
        let message = '已推荐过'
        const nameStr = names.join('、')
        message = `${message}[${nameStr}]到[${this.defaultProject.label}]`
        this.$alert(message)
      } else {
        this.$alert('推荐成功', { showClose: false })
      }
    },
    uploadCv: function() {
      this.attachType = '原始简历'
      this.uploadType = '原始简历'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadReport: function() {
      this.attachType = '推荐报告'
      this.uploadType = '推荐报告'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadSuccess: async function(response, file, fileList) {
      const attach = response.map(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
        }
        dt.rid = this.currentRow._id
        dt.type = this.attachType
        if (this.attachType === '推荐报告') {
          dt.isFinal = true
        }
        return dt
      })
      if (attach.length > 0) {
        const aRes = await app.service('radish').addAttachment(attach)
        if (aRes.status == 'success') {
          this.$message.success({ duration: 500, message: '上传成功' })
          await this.loadOne(this.currentRow._id)
        } else {
          console.log(aRes)
        }
      } else {
        this.$message.info('未添加附件')
      }
      this.$refs.UploadDialog.visible()
      this.$refs.UploadDialog.clean()
    },
    addToFavorite: function() {
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.favDialog.show(rows)
      }
    },
    genRepo: function() {
      app.root.$refs.reportMaker.init({ radish: this.currentRow.rid || this.currentRow._id })
    },
    editOneField: async function(params) {
      const { item, head, value } = params
      const res = await app.service('radish').simpleFetch({ _id: item._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      const data = {}
      const label = head.field || head.label
      data[label] = value
      const result = await app.service('radish').modifyById({ _id: item._id, data: data })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    leaveForecast: async function(item) {
      if (item['公司']) {
        const res = await app.service('radish').leaveForecast(item)
        if (res.status == 'success' && res.data.length > 0) {
          this.bulletins = res.data
          this.popperVisible = true
          this.popperContent = 'bulletin'
          this.currentRow = item
          this.popperTarget = `离职意愿度${item._id}`
          this.loadOne(item._id)
        } else {
          this.$message.info('无相应情报')
        }
      } else {
        this.$message.info('人选无公司')
      }
    },
    showExp: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      if (item['任职经历'] && item['任职经历'].length > 0) {
        this.popperVisible = true
        this.popperContent = 'comExp'
        this.currentRow = item
        this.popperTarget = `任职经历${item._id}`
      } else {
        this.$message.info('无任职经历')
      }
    },
    getSimi: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      if (item.status && item.status > 0) {
        app.root.$refs.simiDialog.show(item)
      }
    },
    showEditDialog: function() {
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      this.$refs.editDialog.show(this.tableHeads, rows)
    },

    showCateDialog: function(type) {
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r._id)
      this.$refs.cateDialog.show(type, this.catData, ids)
    },

    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        const tmp = catData.map(item => item['名称'])
        const tmphead = this.tableHeads.map(t => {
          if (t.label == '职能模块') {
            t.options = tmp
          }
          return t
        })
        this.tableHeads = tmphead
        const prem = app.user['SL权限']
        const role = app.user['角色']
        let tmp2 = []
        if (!role || (!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            tmp2 = []
          } else {
            const catArr = prem.split(';')
            tmp2 = tmp.filter(c => catArr.includes(c))
          }
        } else {
          tmp2 = JSON.parse(JSON.stringify(tmp))
        }
        tmp2.push('空')
        this.searchFields['职能模块'].options = tmp2
        this.searchFields['期望职能'].options = tmp2.slice(0)
      }
      this.searchFields['行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
      // this.searchFields['期望行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
    },
    getProject: async function() {
      if (this.pid) {
        const res = await app.service('project').fetch(this.pid)
        if (res) {
          this.defaultProject = {
            _id: res._id,
            label: `${res['项目名称']}(${res['客户公司']})`,
          }
        }
      }
    },
    setDefault: async function() {
      await this.getProject()
      await this.loadData()
    },
    setMode: function(mode) {
      this.searchMode = mode
      this.$nextTick(function() {
        this.resetTableHeight()
      })
    },
    resetTableHeight: function() {
      const el = this.$refs.radishTableWapper
      el && (this.tableHeight = document.documentElement.clientHeight - el.offsetTop - 120)
    },
    setHiddenCell: function() {
      const heads = localStorage[this.storageName]
      if (heads) {
        const cells = JSON.parse(heads)
        const tmp = this.tableHeads.map(h => {
          if (cells[h.label]) {
            h.hidden = cells[h.label]
          } else {
            h.hidden = false
          }
          return h
        })
        this.tableHeads = tmp
      }
    },
    setCellOrder: function() {
      const headSort = localStorage[`${this.storageName}_sort`]
      if (headSort) {
        const cellSort = JSON.parse(headSort)
        const tmp = this.tableHeads.sort((a, b) => {
          const labelA = a.label
          const labelB = b.label
          // if (cellSort[labelA] > cellSort[labelB]) {
          //   return 1
          // } else {
          //   return -1
          // }
          if (!cellSort[labelA] || cellSort[labelA] > cellSort[labelB]) {
            return 1
          } else {
            return -1
          }
        })
        this.tableHeads = tmp
      }
    },
    orderCondition: function() {
      app.root.$refs.orderDialog.show({
        items: this.searchOrder,
        storageName: 'search',
        onConfirm: () => {
          if (localStorage.search_sort) {
            this.searchOrder = Object.keys(JSON.parse(localStorage.search_sort))
          }
        },
      })
    },
    async deleteAttachment({ _id }) {
      try {
        const { status, msg } = await app.service('radish').deleteAttachment({ _id })
        if (status === 'success') {
          arrRemove(this.files, file => file._id === _id)
          this.$message({ message: msg, type: 'success' })
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
<style>
.radish-pop {
  background-color: #fff;
  border: 1px solid #eee;
  padding: 5px;
  border-radius: 4px;
}
</style>
